export default __webpack_public_path__ + "static/O0164-ff69f9e264b630847a0f76ba9f5e71d1.png";